import { Dices, Landmark, CircleHelp, Gift } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { mediaUrl } from "@/lib/api";
import Reveal from "@/components/Reveal";

const USPS = [
  { icon: Dices, title: "Simple et rapide", text: "Inspiré du jeu de l'oie, compris en 3 minutes. Jouable dès 6 ans, sans que les adultes s'ennuient." },
  { icon: Landmark, title: "100% Nice, 100% Aiglons", text: "Lieux emblématiques de la ville, chants du Populaire Sud, histoire du club, rivalités. Chaque case raconte quelque chose." },
  { icon: CircleHelp, title: "+500 questions", text: "Ville, football, OGC Nice. 4 niveaux de difficulté pour jouer petits et grands. Un QR code pour en débloquer +1000 en ligne." },
  { icon: Gift, title: "Le cadeau parfait", text: "Anniversaire, Noël, fête des pères. Le cadeau qu'on offre à un vrai Niçois et qui fait mouche." },
];

export default function Concept() {
  const { content, settings } = useSite();
  return (
    <section data-testid="concept-section" className="py-16 sm:py-24 lg:py-32">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center mb-16 sm:mb-24">
          <Reveal className="lg:col-span-6">
            <p className="eyebrow mb-4">{content.intro_eyebrow}</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase leading-[1.1] text-onyx">
              {content.intro_title}
            </h2>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-muted-foreground max-w-xl">
              {content.intro_text}
            </p>
          </Reveal>
          <Reveal className="lg:col-span-6" delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-3 bg-med/10 -rotate-1" aria-hidden="true" />
              <img src={mediaUrl(settings?.product_photo_url || "/api/uploads/boite-reelle.jpg")} alt="Photo réelle de la boîte Douzième Homme — Édition Nice"
                className="relative w-full border border-line shadow-brand" loading="lazy" />
            </div>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="usp-grid">
          {USPS.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={i * 0.08}>
              <div className="h-full bg-white border border-line p-7 hover:border-rouge/40 hover:-translate-y-1 transition-all">
                <div className="w-11 h-11 bg-rouge/10 flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5 text-rouge" />
                </div>
                <h3 className="font-display text-xl font-bold tracking-tight text-onyx mb-3">{title}</h3>
                <p className="text-sm leading-relaxed text-muted-foreground">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
